import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c2903a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "game" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 0,
  class: "lastScore"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "assets/logo.svg" })
], -1))
const _hoisted_6 = { class: "menu" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "PLAY", -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "RESUME", -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "SCORE", -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "CLOSE", -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "assets/icon/windows.svg",
  alt: ""
}, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "assets/icon/google-play-badge.png",
  alt: ""
}, null, -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { class: "version" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "https://dead-technologies.de/datenschutz_ed" }, "Privacy Policy", -1))
const _hoisted_21 = [
  _hoisted_20
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EnemyClass = _resolveComponent("EnemyClass")!
  const _component_PowerupClass = _resolveComponent("PowerupClass")!
  const _component_Shots = _resolveComponent("Shots")!
  const _component_Timer = _resolveComponent("Timer")!
  const _component_Score = _resolveComponent("Score")!
  const _component_ScoreBoard = _resolveComponent("ScoreBoard")!
  const _component_Stage = _resolveComponent("Stage")!
  const _component_Cursor = _resolveComponent("Cursor")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, { onMousemove: _ctx.setCursor }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, {
        fullscreen: true,
        "scroll-y": "false",
        "scroll-x": "false"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (_ctx.game.play)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("div", {
                    class: "enemies",
                    style: _normalizeStyle([
              { width: _ctx.game.stage.width + 'px' },
              { height: _ctx.game.stage.height + 'px' },
              { left: _ctx.game.stage.left + 'px' },
            ])
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.game.special, (element) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "specials",
                        key: element
                      }, [
                        (_openBlock(), _createBlock(_component_EnemyClass, {
                          onScreenEnd: ($event: any) => (_ctx.ended('special_1', element)),
                          "data-key": 'special_1',
                          ref_for: true,
                          ref: 
                  (el) => {
                    _ctx.special[element] = true;
                  }
                ,
                          "spawn-delay": _ctx.game.delay,
                          stage: _ctx.game.stage,
                          special: true,
                          key: _ctx.special.obj[element],
                          element: element,
                          muted: _ctx.game.muted
                        }, null, 8, ["onScreenEnd", "spawn-delay", "stage", "element", "muted"]))
                      ]))
                    }), 128)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.game.enemies, (enemy) => {
                      return (_openBlock(), _createElementBlock("div", { key: enemy }, [
                        (_openBlock(), _createBlock(_component_EnemyClass, {
                          onScreenEnd: ($event: any) => (_ctx.ended(enemy, enemy)),
                          "data-key": enemy,
                          ref_for: true,
                          ref: 
                  (el) => {
                    _ctx.enemiesarr[enemy] = true;
                  }
                ,
                          key: _ctx.enemiesarr.obj[enemy],
                          "spawn-delay": _ctx.game.delay,
                          muted: _ctx.game.muted,
                          stage: _ctx.game.stage
                        }, null, 8, ["onScreenEnd", "data-key", "spawn-delay", "muted", "stage"]))
                      ]))
                    }), 128))
                  ], 4),
                  _createElementVNode("div", {
                    class: "powerups",
                    style: _normalizeStyle([
              { width: _ctx.game.stage.width + 'px' },
              { height: _ctx.game.stage.height + 'px' },
              { left: _ctx.game.stage.left + 'px' },
            ])
                  }, [
                    _createVNode(_component_PowerupClass, {
                      stage: _ctx.game.stage,
                      muted: _ctx.game.muted,
                      onPuShot: _ctx.powerUp
                    }, null, 8, ["stage", "muted", "onPuShot"])
                  ], 4),
                  _createVNode(_component_Shots, {
                    shots: _ctx.game.shots
                  }, null, 8, ["shots"]),
                  _createVNode(_component_Timer, {
                    timer: _ctx.game.timer
                  }, null, 8, ["timer"]),
                  _createVNode(_component_Score, {
                    score: _ctx.game.points
                  }, null, 8, ["score"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  (_ctx.game.points)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, " SCORE: " + _toDisplayString(_ctx.game.points), 1))
                    : _createCommentVNode("", true),
                  _hoisted_5,
                  _createElementVNode("div", _hoisted_6, [
                    (!_ctx.game.isPaused)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "btn",
                          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.startGame && _ctx.startGame(...args)))
                        }, _hoisted_8))
                      : _createCommentVNode("", true),
                    (_ctx.game.isPaused)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          class: "btn",
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.resumeGame && _ctx.resumeGame(...args)))
                        }, _hoisted_10))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      class: "btn",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showScores && _ctx.showScores(...args)))
                    }, _hoisted_12),
                    _createElementVNode("button", {
                      class: "btn",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.muteSounds && _ctx.muteSounds(...args)))
                    }, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.game.muted ? "UNMUTE" : "MUTE"), 1)
                    ]),
                    (_ctx.game.electron)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 2,
                          class: "btn",
                          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.closeApp && _ctx.closeApp(...args)))
                        }, _hoisted_14))
                      : _createCommentVNode("", true),
                    (_ctx.isDesktop)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 3,
                          class: "btn downWindows",
                          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.downApp && _ctx.downApp(...args)))
                        }, [
                          _createTextVNode(" DOWNLOAD: "),
                          _hoisted_15,
                          _hoisted_16
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.isDesktop)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 4,
                          class: "",
                          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.downAppGoogle && _ctx.downAppGoogle(...args)))
                        }, _hoisted_18))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("img", {
                    onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.dtClick && _ctx.dtClick(...args))),
                    class: "dt_logo",
                    src: "assets/dt_logo.svg",
                    alt: ""
                  }),
                  _createElementVNode("div", _hoisted_19, [
                    _createTextVNode(_toDisplayString(_ctx.app.version) + " ", 1),
                    (_ctx.isDesktop)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "link",
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.downApp('https://dead-technologies.de/datenschutz_ed')))
                        }, _hoisted_21))
                      : _createCommentVNode("", true)
                  ])
                ])),
            (_ctx.game.showScores)
              ? (_openBlock(), _createBlock(_component_ScoreBoard, {
                  key: 2,
                  onClose: _cache[9] || (_cache[9] = ($event: any) => (_ctx.game.showScores = !_ctx.game.showScores))
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_Stage, {
              game: _ctx.game,
              stage: _ctx.game.stage,
              "onUpdate:stage": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.game.stage) = $event)),
              position: _ctx.game.position,
              "onUpdate:position": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.game.position) = $event))
            }, null, 8, ["game", "stage", "position"]),
            (_ctx.scrollEnabled)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 3,
                  class: "gameLeft",
                  onMouseover: _cache[12] || (_cache[12] = ($event: any) => (_ctx.setBackground($event, 'left'))),
                  onMouseleave: _cache[13] || (_cache[13] = ($event: any) => (_ctx.stopBackground('left')))
                }, null, 32))
              : _createCommentVNode("", true),
            (_ctx.scrollEnabled)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 4,
                  class: "gameRight",
                  onMouseover: _cache[14] || (_cache[14] = ($event: any) => (_ctx.setBackground($event, 'right'))),
                  onMouseleave: _cache[15] || (_cache[15] = ($event: any) => (_ctx.stopBackground('right')))
                }, null, 32))
              : _createCommentVNode("", true),
            _createVNode(_component_Cursor, { cursorPosition: _ctx.cursorPos }, null, 8, ["cursorPosition"])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["onMousemove"]))
}